module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDc2OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNGRkY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5ib3gtdHJhbnNwYXJlbnQ8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY3NywxODZWNjM0SDIyOC45MlYxODZINjc3bTUwLTUwSDE3OC45MlY2ODRINzI3VjEzNloiLz48L3N2Zz4="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/box-transparent.svg
 ** module id = 1280
 ** module chunks = 0
 **/